import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../contexts/LanguageContext';
import '../assets/css/secondnav.css'
import Img from '../assets/images/skillslogo.png'
// import icon1 from '../assets/images/fb.png'
// import icon2 from '../assets/images/em.png'
// import icon3 from '../assets/images/yt.png'
// import icon4 from '../assets/images/wht.png'
// import icon5 from '../assets/images/lin.png'
import icon1 from '../assets/images/fb.png';
import icon2 from '../assets/images/instagram.png';
import icon3 from '../assets/images/yt.png';
import icon4 from '../assets/images/wht.png';
import icon5 from '../assets/images/tiktok1.png';

const SecondNav = () => {
    const { t } = useTranslation();
    const { currentLanguage } = useLanguage();


    const [isOpen, setIsOpen] = useState("third-nav-second");

    const openMenulist = (e) => {
        e.preventDefault();

        console.log(window.location.pathname);
        isOpen === "third-nav-second" ? setIsOpen("third-nav-second nav_active") : setIsOpen("third-nav-second");
    }




    return (


        <div className='NavigationBar' id="SecondNavBarUP">

            {/* first nav bar */}
            <nav id='nav-first-section'>

                {/* logo section */}
                <div className="logo" style={{ padding: "20px" }}>
                    <img src={Img} alt="skillslogo.png" width="200px" style={{ padding: "20px" }} />
                    {/* <h1>eSupport</h1> */}
                </div>

                {/* language-select  desk-view*/}
                <div className="lan-select">

                    <button><a href="/language?lang=en">{t('language.english')}</a></button>
                    <button><a href="/language?lang=si">{t('language.sinhala')}</a></button>
                    <button><a href="/language?lang=ta">{t('language.tamil')}</a></button>
                </div>

                {/* mobile-view */}
                <div className="menu-icon-mob-view">

                    <select
                        value={currentLanguage}
                        onChange={(e) => {
                            const lang = e.target.value;
                            if (lang) {
                                window.location.href = `/language?lang=${lang}`;
                            }
                        }}
                    >
                        <option value="en">{t('language.english')}</option>
                        <option value="si">{t('language.sinhala')}</option>
                        <option value="ta">{t('language.tamil')}</option>
                    </select>

                </div>

            </nav>

            {/* second navbar */}
            <nav className="second-nav-bar">

                {/*<div className="icon-box-nav">*/}

                {/*    <a href="!#"><img src={icon1} alt="" width={25} /></a>*/}
                {/*    <a href="!#"><img src={icon4} alt="" width={25} /></a>*/}
                {/*    <a href="!#"><img src={icon5} alt="" width={25} /></a>*/}
                {/*    <a href="!#"><img src={icon2} alt="" width={25} /></a>*/}
                {/*    <a href="!#"><img src={icon3} alt="" width={25} /></a>*/}
                {/*</div>*/}

                <div className="icon-box-nav">
                    <a href="https://www.facebook.com/share/16ZXfRnfm5/" target="_blank" rel="noopener noreferrer">
                        <img src={icon1} alt="Facebook" width={25}/>
                    </a>
                    <a href="https://whatsapp.com/channel/0029Vb5QkDi7YScwcvgVoL31" target="_blank"
                       rel="noopener noreferrer">
                        <img src={icon4} alt="WhatsApp" width={25}/>
                    </a>
                    <a href="https://www.tiktok.com/@dskills76?_t=ZS-8xKakM8lHWy&_r=1" target="_blank"
                       rel="noopener noreferrer">
                        <img src={icon5} alt="Tiktok" width={35}/>
                    </a>
                    <a href="https://www.instagram.com/invites/contact/?igsh=13t3vvvt0oil2&utm_content=w271u8t"
                       target="_blank" rel="noopener noreferrer">
                        <img src={icon2} alt="Instagram" width={35}/>
                    </a>
                    <a href="https://www.youtube.com/channel/UCOBC6Bjpgpncf5MhjPrWjhg" target="_blank"
                       rel="noopener noreferrer">
                        <img src={icon3} alt="YouTube" width={25}/>
                    </a>
                </div>


                {/* menu icon */}
                <a id='menu-button-second' style={{margin: "0px 0px 0px 10px", textDecoration: "none"}}
                   className='reg-btn-menu-second' href='!' onClick={openMenulist}>
                    <i className="fa-solid fa-bars"></i>
                </a>


            </nav>

            <nav className={isOpen}>

                <div className="menu-list-nav2">

                    <ul className=' menu-list-nav2-ul'>

                        <li><a href="/">{t('nav.home')}</a></li>

                        <li><a href="/events">{t('nav.events')}</a></li>

                         <li id='drop2'>
                            <a href="#">{t('nav.register')} <i className="fa-solid fa-caret-down" style={{ color: "#fff" }}></i></a>
                            <div className="dropdown-content2">
                                <a href="/stdregister">{t('nav.student')}</a>
                                <a href="/insregister">{t('nav.institute')}</a>
                            </div>
                        </li>

                        <li><a href="/aboutus">{t('nav.aboutUs')}</a></li>

                         <li id='drop3'>
                            <a href="#">{t('nav.institutes')} <i className="fa-solid fa-caret-down" style={{ color: "#fff" }}></i></a>
                            <div className="dropdown-content3">
                                <a href="/institutes">{t('nav.privateInstitutes')}</a>
                                <a href="/insfore">{t('nav.foreignInstitutes')}</a>
                            </div>
                        </li>

                        <li id="drop4">
                            <a href="#">{t('nav.courses')} <i className="fa-solid fa-caret-down" style={{ color: "#fff" }}></i></a>
                            <div className="dropdown-content4">
                                <a href="/govcourses">{t('nav.govCourses')}</a>
                                <a href="/govcourses">{t('nav.privateCourses')}</a>
                            </div>
                        </li>

                        <li><a href="/privatecourses">{t('nav.privateUniversities')}</a></li>

                        <li><a href="/studyabroad">{t('nav.studyAbroad')}</a></li>

                        <li><a href="/externaldegree">{t('nav.externalDegree')}</a></li>

                        <li><a href="/professionalexams">{t('nav.professionalExams')}</a></li>

                        <li><a href="/scholarships">{t('nav.scholarships')}</a></li>

                         <li id='drop5'>
                            <a href="#">{t('nav.studentLoans')} <i className="fa-solid fa-caret-down" style={{ color: "#fff" }}></i></a>
                            <div className="dropdown-content2">
                                <a href="/createstdloan">{t('nav.createStudentLoan')}</a>
                                <a href="/stdloan">{t('nav.findStudentLoan')}</a>
                                <a href="/stdloans">{t('nav.allStudentLoans')}</a>
                            </div>
                        </li>

                         <li id='drop5'>
                             <a href='#'>{t('nav.tvecCourses')} <i className="fa-solid fa-caret-down" style={{ color: "#fff" }}></i></a>
                            <div className="dropdown-content2">
                                <a href="#" target="_blank" rel="noopener noreferrer">{t('nav.whatIsTvec')}</a>
                                 <a href="https://www.tvec.gov.lk" target="_blank" rel="noopener noreferrer">{t('nav.tvecServices')}</a>
                                 <a href="http://www.nvq.gov.lk/TVET_GUIDE/" target="_blank" rel="noopener noreferrer">{t('nav.tvecCoursesList')}</a>
                            </div>
                        </li>

                        <li id='drop5'>
                                <a href='#' >{t('nav.govUniversity')} <i className="fa-solid fa-caret-down"></i></a>
                                <div className="dropdown-content2">
                                    <a href="https://www.ugc.ac.lk" target="_blank" rel="noopener noreferrer">{t('nav.ugcSriLanka')}</a>
                                    <a href="/govuni">{t('nav.findGovUniversities')}</a>

                                 </div>
                         </li>

                        <li><a href="/languagequalifications" >{t('nav.languageQualifications')}</a></li>
                    </ul>

                </div>

            </nav>

        </div>
    )
}

export default SecondNav